import { GoogleIcon } from '@/components/icons/GoogleIcon';
import {
	AlertCircle,
	Ambulance,
	BadgeAlert,
	Briefcase,
	BriefcaseMedical,
	Building,
	CalendarCog,
	CalendarDays,
	CircleCheck,
	CircleHelp,
	CircleUserRound,
	CircleX,
	ClipboardPenLine,
	ClipboardPlus,
	Columns3Icon,
	FileUser,
	Hospital,
	Info,
	LayoutDashboard,
	Mail,
	MessageCircleQuestionMark,
	MonitorPlay,
	Phone,
	Shield,
	UserX,
	Stethoscope,
	TentTree,
	TreePalm,
	Users,
	UsersRound,
} from 'lucide-react';

import { ReactNode } from 'react';

const SERVICE_MODALITY_ICON_MAP = {
	FULL_REMOTE: <MonitorPlay className="w-4 text-light" />,
	HYBRID: <BriefcaseMedical className="w-4 text-light" />,
	FULL_PRESENCIAL: <Building className="w-4 text-light" />,
} as const;

const PROFESSIONAL_INFOS_ICON_MAP = {
	google_permissions_allowed: <GoogleIcon className="w-4" />,
	clinic_name: <Hospital className="w-4" />,
	contract: <ClipboardPenLine className="w-4" />,
} as const;

const pageTitleIconClassName = 'w-5 text-dark';
const PAGE_TITLE_ICON = {
	professional: <Stethoscope className={pageTitleIconClassName} />,
	clinic: <Hospital />,
	user: <UsersRound className={pageTitleIconClassName} />,
	session: <ClipboardPlus className={pageTitleIconClassName} />,
	agenda: <CalendarCog className={pageTitleIconClassName} />,
	home: <LayoutDashboard className={pageTitleIconClassName} />,
	profile: <CircleUserRound className={pageTitleIconClassName} />,
	guide: <Info className={pageTitleIconClassName} />,
	faq: <MessageCircleQuestionMark className={pageTitleIconClassName} />,
} as const;

export type ProfessionalInfosIconKeys =
	keyof typeof PROFESSIONAL_INFOS_ICON_MAP;

const USER_DETAIL_TAG_ICON = {
	is_complete: <AlertCircle className="w-4 pb-[1px] text-light" />,
	banned: <CircleX className="w-4 pb-[1px] text-light" />,
	not_banned: <CircleCheck className="w-4 pb-[1px] text-light" />,
	is_member: <Briefcase className="w-4 pb-[1px] text-light" />,
	is_not_member: <UserX className="w-4 pb-[1px] text-light" />,
	google_id: <Shield className="w-4 pb-[1px] text-light" />,
	email_auth: <Mail className="w-4 pb-[1px] text-light" />,
};

const useDetailIconClass = 'w-4 pb-[2px] text-dark';
const USER_DETAIL_ICON = {
	email: <Mail className={useDetailIconClass} />,
	phone_number: <Phone className={useDetailIconClass} />,
	birthday: <CalendarDays className={useDetailIconClass} />,
	google_permissions_allowed: <GoogleIcon className={useDetailIconClass} />,
	created_at: <CalendarDays className={useDetailIconClass} />,
	last_login: <CalendarDays className={useDetailIconClass} />,
	last_ban: <CalendarDays className={useDetailIconClass} />,
	last_ban_reason: <CircleHelp className={useDetailIconClass} />,
} as const;

export type UserDetailIconKeys = keyof typeof USER_DETAIL_ICON;

const unavailabilityIconClass =
	'text-gray-700 stroke-1 stroke-zinc-200 fill-current size-4';

const UNAVAILABILITY_ICON: Record<
	ProfessionalUnavailabilitys.UnavailabilityType,
	ReactNode
> = {
	CONFERENCE: <Users className={unavailabilityIconClass} />,
	CUSTOM: <Columns3Icon className={unavailabilityIconClass} />,
	HOLIDAY: <TentTree className={unavailabilityIconClass} />,
	MEDICAL_LEAVE: <Ambulance className={unavailabilityIconClass} />,
	PERSONAL_DAY: <FileUser className={unavailabilityIconClass} />,
	TECHNICAL_ISSUE: <BadgeAlert className={unavailabilityIconClass} />,
	VACATION: <TreePalm className={unavailabilityIconClass} />,
} as const;

export {
	SERVICE_MODALITY_ICON_MAP,
	PROFESSIONAL_INFOS_ICON_MAP,
	PAGE_TITLE_ICON,
	USER_DETAIL_TAG_ICON,
	USER_DETAIL_ICON,
	UNAVAILABILITY_ICON,
};
